/* 鮮拾 10Mart 品牌直播間 */

import type { ReactNode } from 'react'
import classnames from 'classnames/bind'

// Libs

// Components

// Constants

// Context

// Styles
import styles from './style.module.scss'

// Variables
const cx = classnames.bind(styles)

type BasicLayoutProps = {
  children: ReactNode
}

// 全聯要嵌直播間在他們網頁，所以不放 header
const PXECLayout = (props: BasicLayoutProps) => {
  const { children } = props

  return (
    <div id='layout' className={cx('layout')}>
      {/* <SimpleHeader /> */}

      <div className={cx('layout-body')}>{children}</div>
    </div>
  )
}

export default PXECLayout
